import React from 'react';
import { fetchPaywayTransactions } from 'actions/paywayTransactions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { date } from 'utils/date';
import { dollars } from 'utils/money';
import { Link } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Divider from '@material-ui/core/Divider';
import { toggleNotification } from '/actions/commonActions';
import LoanDialog from 'components/Loans/LoanDialog';

const styles = theme => ({});

export class List extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchPaywayTransactions());
  }

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <CircularProgress color='primary' thickness={7} style={{position: 'absolute', zIndex: '1', top: '50%', left: '50%'}}/>
      );
    }
  }

  renderPaywayTransactions = (paywayTransactions) => {
    return (
      <Table data-test='paywayTransactionsTable'>
        <TableHead>
          <TableRow>
            <TableCell>Customer Name</TableCell>
            <TableCell>Loan</TableCell>
            <TableCell>Matched repayment date</TableCell>
            <TableCell>Settlement Date</TableCell>
            <TableCell>Declined Date</TableCell>
            <TableCell>Transaction ID</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          { Object.values(paywayTransactions).map(this.renderPaywayTransaction) }
        </TableBody>
      </Table>
    );
  }

  renderPaywayTransaction = (paywayTransaction) => {
    const { loan } = paywayTransaction;

    return (
      <TableRow key={paywayTransaction.id}>
        <TableCell>
          {paywayTransaction.paywayCustomer.paywayName}
        </TableCell>
        <TableCell>
          {
            loan && <LoanDialog
              loan={loan}
              buttonLabel={loan.loanNumber}
              highlightScheduleID={paywayTransaction.repayment && paywayTransaction.repayment.id}
            />
          }
        </TableCell>
        <TableCell>
          {paywayTransaction.repayment && date(paywayTransaction.repayment.repaymentDatetime)}
        </TableCell>
        <TableCell>
          {date(paywayTransaction.settlementDate)}
        </TableCell>
        <TableCell>
          {date(paywayTransaction.declinedDate)}
        </TableCell>
        <TableCell>
          {paywayTransaction.transactionId}
        </TableCell>
        <TableCell>
          {paywayTransaction.status}
        </TableCell>
        <TableCell>
          {dollars(paywayTransaction.paymentAmount)}
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { paywayTransactions, classes } = this.props;

    return (
      <div>
        <div style={{ display: 'flex' }}>
          <Typography variant='headline' className={classes.flex}>
            Payway Transactions
          </Typography>
        </div>
        <Divider light />
        { paywayTransactions ? this.renderPaywayTransactions(paywayTransactions) : this.renderSpinner() }
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const { paywayTransactions } = state;
  return { paywayTransactions: paywayTransactions.paywayTransactions };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/PaywayTransactions/List.js